export enum AllotmentNodeTags {
    LOT_ENERGY = 1, // Energy and simplified energy rules are applied to this node
    LOT_WATER = 2,  // Waters rules is applied to this node
};